module.exports = __webpack_public_path__ + "img/voucher.ffb25c92.webp";